import * as React from 'react';
import antd from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import styled from 'styled-components';
import FormControl from '../../Forms/FormControl';

const { Form } = antd;

export const StyleConfirmEmailForm = styled(Form)`
  max-width: 300px;
  min-width: 300px;

  .login-form-forgot {
    float: left;
  }

  .login-form-sign-up{
    float: right;
  }

  .login-form-button {
    width: 100%;
    background-color: rgb(174, 24, 87);
  }
`;
















